'use client'

import { ArrowLeftIcon } from '@phosphor-icons/react'

/**
 * 根级 404 页面
 * 注意：此页面需要自己包含完整的 HTML 结构，
 * 因为根 layout.tsx 只返回 children
 */
export default function NotFound() {
  const handleGoBack = () => {
    window.location.replace('/')
  }

  return (
    <html className="h-full" lang="en">
      <body className="h-full">
        <div className="flex h-full w-full items-center justify-center bg-primary">
          <div className="flex flex-col items-center justify-center gap-6 text-center">
            <div className="flex flex-col items-center gap-4">
              <h1 className="text-8xl font-bold text-white/20">404</h1>
              <h2 className="text-2xl font-semibold text-white">Page Not Found</h2>
              <p className="max-w-md text-sm text-white/60">
                The page you are looking for does not exist.
              </p>
            </div>

            <button
              className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-primary hover:scale-105"
              onClick={handleGoBack}
            >
              <ArrowLeftIcon className="size-5" />
              Go Back
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
